<h2 class="sectionTitle">{{ Heading }}</h2>
<h6 class="packages-subtext">
  <span>{{ Subtext }}</span>
</h6>
<div class="row medium">
  <div class="col-md-12">
    @if (Loading) {
    <div><span>Loading...</span></div>
    }
    @else {
    <div>
      <wj-flex-grid [allowDragging]="'None'" 
        [selectionMode]="'None'" 
        [allowResizing]="'None'" 
        [headersVisibility]="'Column'"
        [itemsSource]="collectionView" 
        [isReadOnly]="true" 
        width="100%" 
        [autoGenerateColumns]="false">
        <wj-flex-grid-column width=".55*" header="Type" binding="PackageName">
          <ng-template [cellType]="'Cell'" wjFlexGridCellTemplate let-item="item">
            @if(canOpenPackagesAddons && item?.PackageType !== 'BillOnly' && item?.PackageType !== "RecurringUsage"){
              <a href="javascript:void(0)" (click)="SelectPackage(item)" class="no-href-link">{{
              item.PackageName
            }}</a>
            } @else {
              {{ item.PackageName }}
            }
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column width=".15*" header="Seats" binding="NumberAllowed" align="center"></wj-flex-grid-column>
        <wj-flex-grid-column width=".15*" header="Assigned" binding="NumberUsed" align="center">
          <ng-template [cellType]="'Cell'" wjFlexGridCellTemplate let-item="item">
            @if(isAddOns && (item?.PackageType === 'BillOnly' || item?.PackageType === 'RecurringUsage')) {
              N/A
            } @else {
              {{ item.NumberUsed }}
            }
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column width=".15*" header="Remaining" align="center">
          <ng-template [cellType]="'Cell'" wjFlexGridCellTemplate let-item="item">
            @if(isAddOns && (item?.PackageType === 'BillOnly' || item?.PackageType === 'RecurringUsage')){
              N/A
            } @else {
            {{ item.NumberAllowed - item.NumberUsed }}
            }
          </ng-template>
        </wj-flex-grid-column>
      </wj-flex-grid>
    </div>
    }
  </div>
</div>